import { Logo } from "@/components/display";
import { Form, useForm } from "@/components/form";
import { useAuthContext } from "@/features/auth/contexts/auth-context";
import { Card, Stack, Typography } from "@mui/material";
import { z } from "zod/v4";

const setPasswordFormSchema = z.object({
    password: z.string().min(6, { message: "La contraseña debe tener 6 o más carácteres" }),
    confirmPassword: z.string()
}).refine(value => value.password === value.confirmPassword, {
    message: "Las contraseñas no coinciden.",
    path: ["confirmPassword"]
});

export default function SetPasswordPage() {
    const { setPassword } = useAuthContext();

    const setPasswordForm = useForm({
        defaultValues: {
            password: "",
            confirmPassword: ""
        } as z.input<typeof setPasswordFormSchema>,
        onSubmit: async ({ value }) => await setPassword(value.password),
        validators: {
            onSubmit: setPasswordFormSchema
        },
        submitOnce: true
    })

    return <Stack justifyContent={"center"} alignItems={"center"} sx={{ backgroundColor: "primary.light", minHeight: "100vh" }}>
        <Card sx={{ width: "100%", maxWidth: "400px" }}>
            <Form form={setPasswordForm} gap={3} padding={5}>
                <Stack gap={2}>
                    <Logo alignSelf={"center"} />
                    <Stack gap={1}>
                        <Typography component="h1" variant="h5">Cambiar Contraseña</Typography>
                        <Typography component="h2" variant="body1" color="text.secondary">
                            Has iniciado sesión con una contraseña temporal. Por favor ingrese una contraseña nueva.
                        </Typography>
                    </Stack>
                </Stack>
                <Form.PasswordField name="password" label="Nueva Contraseña" />
                <Form.PasswordField name="confirmPassword" label="Confirmar Contraseña" />
                <Form.SubmitButton variant="contained">Cambiar Contraseña</Form.SubmitButton>
            </Form>
        </Card>
    </Stack>
}